import { render, staticRenderFns } from "./InformationPromotion.vue?vue&type=template&id=661c5fe4&scoped=true&"
import script from "./InformationPromotion.vue?vue&type=script&lang=js&"
export * from "./InformationPromotion.vue?vue&type=script&lang=js&"
import style0 from "./InformationPromotion.vue?vue&type=style&index=0&id=661c5fe4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661c5fe4",
  null
  
)

export default component.exports